export const AP_MODAL_ADD_COMPONENT = 'AP_MODAL_ADD_COMPONENT';
export const AP_MODAL_SET_STATUS = 'AP_MODAL_SET_STATUS';